import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../../_common/enum/forms/fomTemplateType.enum";
import { FormIndex } from "../../form/form-index";
import { StandardPanel } from "../../../_components/panel/standard.panel";
import { ClientFormManageDrawer } from "./client-formManageDrawer";

export function ClientFormPanel() {
  const { clientId } = useParams<{ clientId: string }>();
  const navigate = useNavigate();


  return <>
    <StandardPanel title={"Client Forms"} loading={false} buttons={[
      { label: "+ Create", shrink: true, onClick: () => { navigate("Manage/Forms/") } },
    ]}>
      <FormIndex formType={FormTemplateTypeEnum.Client} title="Client Forms" id={clientId} />
    </StandardPanel>

    <Routes>
      <Route path="Manage/Forms/" element={<ClientFormManageDrawer onClose={() => { navigate("") }} />} />
    </Routes>
  </>
}